import { FormType } from '../../../../form-types';

export const wlus_032025: FormType = {
  name: 'Weight Loss',
  olderVersions: ['wlus_2024', 'wlus_archived'],
  questions: [
    {
      key: 'wlus_genderIdentify',
      next: {
        condition: {
          'wlus_genderIdentify.wlus_genderIdentify_male': true
        },
        key: 'wlus_weightAndHeight2025',
        els: 'wlus_pregnantOrBreastfeedingOrPlanningTo'
      }
    },
    {
      key: 'wlus_pregnantOrBreastfeedingOrPlanningTo',
      next: {
        condition: {
          'wlus_pregnantOrBreastfeedingOrPlanningTo.wlus_PregnantOrBreastfeedingOrPlanningTo_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_consentPregnancy'
      }
    },
    {
      key: 'wlus_consentPregnancy',
      next: {
        condition: {
          'wlus_consentPregnancy.wlus_consentPregnancy_non_consent': true
        },
        key: 'wlus_ineligible',
        els: 'wlus_weightAndHeight2025'
      }
    },
    'wlus_weightAndHeight2025',
    {
      key: 'wlus_consentBmi',
      next: {
        condition: {
          'wlus_consentBmi.wlus_consentBmi_non_consent': true
        },
        key: 'wlus_ineligible',
        els: 'wlus_MedicalConditions'
      }
    },
    {
      key: 'wlus_MedicalConditions',
      next: {
        switch: [
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_noneOfTheAbove':
                true
            },
            key: 'wlus_hadAGastricBypassInThePast6Months'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_gastroparesis':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_triglyceridesOver600AtAnyPoint':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_pancreaticCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_pancreatitis': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_type1Diabetes':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_hypoglycemia': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_insulinDependentDiabetes':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_thyroidCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_familyHistoryOfThyroidCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_familyHistoryOfMultipleEndocrineNeoplasiaMEN2Syndrome':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_anorexiaOrBulimia':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_currentSymptomaticGallstones':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_gallbladderRemoved':
                true
            },
            key: 'wlus_consentGallbladder'
          }
        ],
        els: 'wlus_tellUsMoreAboutAboutYourMedicalConditions'
      }
    },
    {
      key: 'wlus_consentGallbladder',
      next: {
        condition: {
          'wlus_consentGallbladder.wlus_consentGallbladder_consent': true
        },
        key: 'wlus_tellUsMoreAboutAboutYourMedicalConditions',
        els: 'wlus_ineligible'
      }
    },

    'wlus_tellUsMoreAboutAboutYourMedicalConditions',
    {
      key: 'wlus_hadAGastricBypassInThePast6Months',
      next: {
        condition: {
          'wlus_hadAGastricBypassInThePast6Months.wlus_hadAGastricBypassInThePast6Months_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_allergicToAnyOfTheFollowing'
      }
    },
    {
      key: 'wlus_allergicToAnyOfTheFollowing',
      next: {
        condition: {
          'wlus_allergicToAnyOfTheFollowing.wlus_allergicToAnyOfTheFollowing_noneOfTheAbove':
            true
        },
        key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
      next: {
        condition: {
          'wlus_doYouTakeAnyOfTheFollowingMedications.wlus_doYouTakeAnyOfTheFollowingMedications_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications'
      }
    },
    {
      key: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications',
      next: {
        switch: [
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_semiglutide':
                true
            },
            key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication'
          },
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_tirzepatide':
                true
            },
            key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication'
          }
        ],

        els: 'wlus_medicationSensitivities'
      }
    },
    {
      key: 'wlus_medicationSensitivities',
      next: {
        key: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    {
      key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication',
      next: {
        condition: {
          'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication.wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes':
            true
        },
        key: 'wlus_describeTheSideEffectsThatYouHaveExperienced',
        els: 'wlus_howDoingOnMedication'
      }
    },
    'wlus_describeTheSideEffectsThatYouHaveExperienced',
    {
      key: 'wlus_howDoingOnMedication',
      next: {
        condition: {
          // Decided in next question
          'wlus_howDoingOnMedication.sharedDecision': true
        },
        key: 'wlus_sharedDecisionMaking',
        els: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
      }
    },
    'wlus_sharedDecisionMaking',
    'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    'wlus_howWouldYouLikeToContinueYourTreatment',
    {
      key: 'wlus_doYouHaveAPictureOfYourCurrentPrescription',
      next: {
        condition: {
          'wlus_doYouHaveAPictureOfYourCurrentPrescription.wlus_doYouHaveAPictureOfYourCurrentPrescription_yes':
            true
        },
        key: 'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',
        els: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',
    'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    {
      key: 'wlus_consentTruthfulness',
      next: {
        condition: {
          'wlus_consentTruthfulness.wlus_consentTruthfulness_consent': true
        },
        key: 'wlus_consentGLP1GIP',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_consentGLP1GIP',
      next: {
        condition: {
          'wlus_consentGLP1GIP.wlus_consentGLP1GIP_non_consent': true
        },

        key: 'wlus_ineligible',
        els: 'wlus_complete'
      }
    },
    'wlus_ineligible',
    'wlus_complete'
  ]
};

export const wlus_2024: FormType = {
  name: 'Weight Loss',
  olderVersions: ['wlus_archived'],
  questions: [
    {
      key: 'wlus_genderIdentify',
      next: {
        condition: {
          'wlus_genderIdentify.wlus_genderIdentify_male': true
        },
        key: 'wlus_weightAndHeight2025',
        els: 'wlus_pregnantOrBreastfeedingOrPlanningTo'
      }
    },
    {
      key: 'wlus_pregnantOrBreastfeedingOrPlanningTo',
      next: {
        condition: {
          'wlus_pregnantOrBreastfeedingOrPlanningTo.wlus_PregnantOrBreastfeedingOrPlanningTo_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_consentPregnancy'
      }
    },
    {
      key: 'wlus_consentPregnancy',
      next: {
        condition: {
          'wlus_consentPregnancy.wlus_consentPregnancy_non_consent': true
        },
        key: 'wlus_ineligible',
        els: 'wlus_weightAndHeight2025'
      }
    },
    'wlus_weightAndHeight2025',
    {
      key: 'wlus_consentBmi',
      next: {
        condition: {
          'wlus_consentBmi.wlus_consentBmi_non_consent': true
        },
        key: 'wlus_ineligible',
        els: 'wlus_MedicalConditions'
      }
    },
    {
      key: 'wlus_MedicalConditions',
      next: {
        switch: [
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_noneOfTheAbove':
                true
            },
            key: 'wlus_hadAGastricBypassInThePast6Months'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_gastroparesis':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_triglyceridesOver600AtAnyPoint':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_pancreaticCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_pancreatitis': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_type1Diabetes':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_hypoglycemia': true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_insulinDependentDiabetes':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_thyroidCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_familyHistoryOfThyroidCancer':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_familyHistoryOfMultipleEndocrineNeoplasiaMEN2Syndrome':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_anorexiaOrBulimia':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_currentSymptomaticGallstones':
                true
            },
            key: 'wlus_ineligible'
          },
          {
            condition: {
              'wlus_MedicalConditions.wlus_MedicalConditions_gallbladderRemoved':
                true
            },
            key: 'wlus_consentGallbladder'
          }
        ],
        els: 'wlus_tellUsMoreAboutAboutYourMedicalConditions'
      }
    },
    'wlus_consentGallbladder',
    'wlus_tellUsMoreAboutAboutYourMedicalConditions',
    // 'wlus_identifyAllYourCurrentMedicalConditions',
    // 'wlus_listAllYourCurrentMedicationsIncludingDosages',
    // 'wlus_listAllOfYourKnownAllergies',
    {
      key: 'wlus_hadAGastricBypassInThePast6Months',
      next: {
        condition: {
          'wlus_hadAGastricBypassInThePast6Months.wlus_hadAGastricBypassInThePast6Months_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_allergicToAnyOfTheFollowing'
      }
    },
    {
      key: 'wlus_allergicToAnyOfTheFollowing',
      next: {
        condition: {
          'wlus_allergicToAnyOfTheFollowing.wlus_allergicToAnyOfTheFollowing_noneOfTheAbove':
            true
        },
        key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
      next: {
        condition: {
          'wlus_doYouTakeAnyOfTheFollowingMedications.wlus_doYouTakeAnyOfTheFollowingMedications_yes':
            true
        },
        key: 'wlus_ineligible',
        els: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications'
      }
    },
    {
      key: 'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications',
      next: {
        switch: [
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_semiglutide':
                true
            },
            key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication'
          },
          {
            condition: {
              'wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications.wlus_AreYouCurrentlyOrHaveYouInThePastTwoMonthsTakenAnyOfTheFollowingMedications_tirzepatide':
                true
            },
            key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication'
          }
        ],

        els: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    {
      key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication',
      next: {
        condition: {
          'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication.wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes':
            true
        },
        key: 'wlus_describeTheSideEffectsThatYouHaveExperienced',
        els: 'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose'
      }
    },
    'wlus_describeTheSideEffectsThatYouHaveExperienced',
    'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    'wlus_howWouldYouLikeToContinueYourTreatment',
    {
      key: 'wlus_doYouHaveAPictureOfYourCurrentPrescription',
      next: {
        condition: {
          'wlus_doYouHaveAPictureOfYourCurrentPrescription.wlus_doYouHaveAPictureOfYourCurrentPrescription_yes':
            true
        },
        key: 'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',
        els: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',
    // 'wlus_identityVerification',
    // 'wlus_fullBodyImage',
    'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    {
      key: 'wlus_consentTruthfulness',
      next: {
        condition: {
          'wlus_consentTruthfulness.wlus_consentTruthfulness_consent': true
        },
        key: 'wlus_consentGLP1GIP',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_consentGLP1GIP',
      next: {
        condition: {
          'wlus_consentGLP1GIP.wlus_consentGLP1GIP_non_consent': true
        },

        key: 'wlus_ineligible',
        els: 'wlus_complete'
      }
    },
    'wlus_ineligible',
    'wlus_complete'
  ]
};

export const wlus_archived: FormType = {
  name: 'Weight Loss [Archived]',
  questions: [
    [
      {
        key: 'wlGenderIdentify',
        next: {
          condition: { 'wlGenderIdentify.male': true },
          key: 'wlwWhatisWeightHeight',
          els: 'wlPregnant' //'wlusIsCurrentlyTakingSpecificMedication'
        }
      },
      {
        key: 'wlPregnant',
        next: {
          condition: { 'wlPregnant.isNo': false },
          key: 'wlIneligible',
          els: 'wlBreastfeeding'
        }
      },
      {
        key: 'wlBreastfeeding',
        next: {
          condition: { 'wlBreastfeeding.isNo': false },
          key: 'wlIneligible',
          els: 'wlPregnancyBrestFeedingConsent'
        }
      },
      'wlIneligible'
    ],
    'wlPregnancyBrestFeedingConsent',
    'wlwWhatisWeightHeight',
    {
      key: 'wlMedicalChanges',
      next: {
        condition: {
          'wlMedicalChanges.gastroparesis': false,
          'wlMedicalChanges.inflammatorybowl': false,
          'wlMedicalChanges.pancreatitis': false,
          'wlMedicalChanges.pancreaticCancer': false,
          'wlMedicalChanges.insulinDiabetes': false,
          'wlMedicalChanges.thyroidCancer': false,
          'wlMedicalChanges.familyHistoryThyroidCancer': false,
          'wlMedicalChanges.MEN2': false,
          'wlMedicalChanges.eatingDisorder': false,
          'wlMedicalChanges.anorexia': false
        },
        key: 'wlGallbladder',
        els: 'wlIneligible'
      }
    },
    {
      key: 'wlGallbladder',
      next: {
        condition: { 'wlGallbladder.isNo': false },
        key: 'wlGallbladderConsent',
        els: 'wlGastricBypass'
      }
    },
    'wlGallbladderConsent',
    'wlGastricBypass',
    {
      key: 'wlMedsAllergic',
      next: {
        condition: { 'wlMedsAllergic.noMedsAllergies': false },
        key: 'wlIneligible',
        els: 'wlTakingMeds'
      }
    },
    {
      key: 'wlTakingMeds',
      next: {
        condition: { 'wlTakingMeds.isNo': false },
        key: 'wlIneligible',
        els: 'wlGLP1Meds'
      }
    },
    {
      key: 'wlGLP1Meds',
      next: {
        condition: { 'wlGLP1Meds.none': true },
        key: 'wlDoctorQuestion',
        els: 'wlMedCloseDose'
      }
    },
    'wlMedCloseDose',
    'wlContinueTreatment',
    'wlDoctorQuestion'
  ]
};

export const wl: FormType = {
  name: 'Weight Loss',
  questions: [
    'wlGenderIdentify',
    'wlCisgenderWoman',
    'wlDecribesYou',
    'wlwWhatisWeightHeight',
    'wlPantSize',
    'educationSlide1',
    'wlFamilyHealthCondition',
    'wlFamilyHistory',
    'wlfearNeedles',
    'wlArea',
    'educationSlide2',
    'wlWLGoals',
    'wlILikeTo',
    'wlBarriers',
    'wlallergies',
    'educationSlide4',
    'wlYourSleep',
    'wlMood',
    'educationSlide3',
    'wlCurrentHabits',
    'wlCoveredMedications',
    'educationSlide5',
    'wlLossWeightSixMonth',
    'wlmodificationsDiet',
    'wlWhatDiet',
    'educationSlide6'
  ]
  /*  onSubmit: (answers: Answers) => {
      ConsultationUtils.answers = answers;
      // window.location.href = "https://calendly.com/bianca-cordeiro-rd/intro-call";
      window.location.href =
        'https://calendly.com/catrina-jackhealth/welcome-call-wl-program';
    } */
};
